function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 35,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 85.333h512V426.67H0z",
    style: {},
    fill: "#f0f0f0",
    "data-original": "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z",
    style: {},
    fill: "#d80027",
    "data-original": "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.785 315.358 512 381.034v-65.676zM311.652 315.358 512 426.662v-31.474l-143.693-79.83zM458.634 426.662l-146.982-81.664v81.664z",
    style: {},
    fill: "#0052b4",
    "data-original": "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z",
    style: {},
    fill: "#f0f0f0",
    "data-original": "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z",
    style: {},
    fill: "#d80027",
    "data-original": "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.341 315.356 0 365.546v-50.19zM200.348 329.51v97.151H25.491z",
    style: {},
    fill: "#0052b4",
    "data-original": "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.693 315.358 0 395.188v31.474l200.348-111.304z",
    style: {},
    fill: "#d80027",
    "data-original": "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.215 196.634 0 130.958v65.676zM200.348 196.634 0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z",
    style: {},
    fill: "#0052b4",
    "data-original": "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z",
    style: {},
    fill: "#f0f0f0",
    "data-original": "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z",
    style: {},
    fill: "#d80027",
    "data-original": "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.659 196.636 512 146.446v50.19zM311.652 182.482V85.331h174.857z",
    style: {},
    fill: "#0052b4",
    "data-original": "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.307 196.634 512 116.804V85.33L311.652 196.634z",
    style: {},
    fill: "#d80027",
    "data-original": "#d80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.87bb6ad26eec3623aa7b4d1b03dc1a9a.svg";
export { ForwardRef as ReactComponent };